module.exports = __webpack_public_path__ + "img/card6.094b6c56.png";